import React from 'react';
import { Box, Typography } from '@mui/material';

type Props = {
  src?: string;
  name?: string;
  maxWidth: number;
  maxHeight: number;
  color?: string;
};

export const BrandLogo: React.FC<Props> = ({
  src,
  name,
  maxWidth,
  maxHeight,
  color,
}) => {
  if (src) {
    return (
      <Box
        component="img"
        src={src}
        alt={name ?? 'logo'}
        sx={{ maxWidth, maxHeight }}
      />
    );
  }

  return (
    <Typography
      variant="Poppins/Heading-4"
      sx={{ color: color ?? 'text.primary', maxWidth: maxWidth * 1.5 }}
      noWrap
    >
      {name}
    </Typography>
  );
};
